<template>
  <div id="all-shipping-labels-template" class="d-none">
    <ShippingLabel
      v-for="label in labels"
      :key="label.deliveryId"
      :store-logo="label.storeLogoUrl || ''"
      :store-name="label.storeName || ''"
      :qr-svg="label.qrSvg"
      :tracking-code="label.trackingCode || String(label.deliveryId || '')"
      :custom-field1="label.customField1 || ''"
      :custom-field2="label.customField2 || ''"
      :recipient="label.recipient || { name: '', address: '', phone: '' }"
    />
  </div>
</template>

<script>
import { Printd } from 'printd'
import ShippingLabel from './ShippingLabel.vue'
import css from './css_v2'
import { withQrSvg } from '../../../utils/qrSvg'

export default {
  name: 'PrintShippingLabels',
  components: { ShippingLabel },
  data () {
    return {
      labels: []
    }
  },
  methods: {
    /**
     * Recibe el array de labels (shape devuelto por GET /delivery/labels-by-ids)
     * y los renderiza off-screen dentro de `#all-shipping-labels-template`,
     * luego dispara la impresión con `printd`.
     *
     * Spec 008: el QR ya viene resuelto como data URI (`label.qrSvg`) porque
     * `withQrSvg` espera a que TODOS los QRs estén generados antes de asignar
     * `this.labels`. Antes el QR se generaba dentro de cada `ShippingLabel` con
     * un watch async + `immediate: true`, lo que provocaba que el print corriera
     * con la imagen del QR todavía vacía.
     */
    async print (labels) {
      if (!Array.isArray(labels) || labels.length === 0) return
      const resolved = await withQrSvg(labels)
      this.labels = resolved
      this.$nextTick(() => {
        const d = new Printd()
        d.print(document.getElementById('all-shipping-labels-template'), [css])
      })
    }
  }
}
</script>